import React, { useEffect, useState } from 'react';
import axios from 'axios';

const WaitingRegister = () => {
  const params = new URLSearchParams(window.location.search);
  const shopId = Number(params.get('shop_id') || 0);

  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [people, setPeople] = useState('2');
  const [msgHtml, setMsgHtml] = useState('');

  function onlyNum(s) {
    return (s || '').replace(/[^0-9]/g, '');
  }

  useEffect(() => {
    const init = async () => {
      try {
        const res = await axios.get(`/api/waiting/register-init?shop_id=${encodeURIComponent(shopId)}`, {
          withCredentials: true,
        });

        if (!res.data || res.data.ok !== true) {
          alert((res.data && res.data.message) || 'shop_id 없음');
          return;
        }

        setShopName(res.data.shop_name || '알 수 없는 가게');
      } catch (e) {
        console.error(e);
        alert('초기화 실패');
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [shopId]);

  const submit = async () => {
    const cleanName = name.trim();
    const cleanPhone = onlyNum(phone.trim());
    const peopleNum = parseInt(people, 10);

    setMsgHtml('');

    if (!cleanName) {
      setMsgHtml('<div class="alert alert-danger">이름을 입력해주세요.</div>');
      return;
    }
    if (!cleanPhone || cleanPhone.length < 9) {
      setMsgHtml('<div class="alert alert-danger">전화번호를 확인해주세요.</div>');
      return;
    }
    if (!peopleNum || peopleNum < 1) {
      setMsgHtml('<div class="alert alert-danger">인원을 선택해주세요.</div>');
      return;
    }

    const fd = new FormData();
    fd.append('shop_id', String(shopId));
    fd.append('name', cleanName);
    fd.append('phone', cleanPhone);
    fd.append('people', String(peopleNum));

    try {
      const res = await axios.post('/api/waiting/register-api', fd, {
        withCredentials: true,
      });

      const j = res.data;
      if (!j.success) {
        setMsgHtml(`<div class="alert alert-danger">${j.message || '등록 실패'}</div>`);
        return;
      }

      window.location.href = `/waiting/status?shop_id=${shopId}&waiting_id=${j.waiting_id}&token=${encodeURIComponent(j.token)}`;
    } catch (e) {
      console.error(e);
      setMsgHtml('<div class="alert alert-danger">등록 실패</div>');
    }
  };

  if (loading) {
    return <div className="p-3">불러오는 중...</div>;
  }

  return (
    <>
      <style>{`
        :root{
          --brand:#0d6efd;
          --brand2:#0b5ed7;
          --bg:#ffffff;
          --card:#ffffff;
          --muted:#8b8f9b;
          --line:#eceef5;
          --shadow:0 10px 24px rgba(16,24,40,.08);
          --radius:18px;
        }
        body{ background:var(--bg); }
        .appbar{
          height:56px;
          display:flex;
          align-items:center;
          justify-content:center;
          position:sticky;
          top:0;
          background:#fff;
          border-bottom:1px solid var(--line);
          z-index:10;
        }
        .appbar .title{
          font-weight:900;
          letter-spacing:-0.2px;
        }
        .page{
          max-width:520px;
          margin:0 auto;
          padding:16px 16px 120px;
        }
        .shopname{
          font-weight:900;
          font-size:28px;
          letter-spacing:-0.6px;
          text-align:center;
          margin-top:8px;
        }
        .hello{
          text-align:center;
          color:var(--muted);
          font-size:13px;
          line-height:1.5;
          margin:8px 0 16px;
        }
        .cardbox{
          background:var(--card);
          border:1px solid var(--line);
          border-radius:var(--radius);
          box-shadow:var(--shadow);
          padding:16px;
        }
        .form-label{
          font-weight:900;
          font-size:13px;
          margin-bottom:8px;
        }
        .form-control, .form-select{
          border-radius:16px;
          border:1px solid var(--line);
          padding:12px 12px;
          font-weight:700;
        }
        .form-control:focus, .form-select:focus{
          border-color:rgba(108,99,255,.6);
          box-shadow:0 0 0 .2rem rgba(108,99,255,.14);
        }
        .form-text{ color:var(--muted); }
        .bottom-cta{
          position:fixed;
          left:0; right:0;
          bottom:0;
          padding:12px 16px calc(12px + env(safe-area-inset-bottom));
          background:rgba(255,255,255,.92);
          backdrop-filter: blur(10px);
          border-top:1px solid var(--line);
          z-index:20;
        }
        .bottom-cta .wrap{
          max-width:520px;
          margin:0 auto;
        }
        .btn-brand{
          height:56px;
          width:100%;
          border:none;
          border-radius:16px;
          background:var(--brand);
          color:#fff;
          font-weight:900;
          font-size:16px;
          letter-spacing:-0.2px;
        }
        .btn-brand:active{ transform: translateY(1px); }
        .btn-brand:hover{ background:var(--brand2); }
        #msg .alert{
          border-radius:16px;
          border:1px solid var(--line);
          margin-top:14px;
        }
        input.form-control::placeholder,
        textarea.form-control::placeholder{
          color:#c2c6d0 !important;
          opacity:1 !important;
        }
        input.form-control::-webkit-input-placeholder,
        textarea.form-control::-webkit-input-placeholder{
          color:#c2c6d0 !important;
        }
        input.form-control::-moz-placeholder,
        textarea.form-control::-moz-placeholder{
          color:#c2c6d0 !important;
          opacity:1 !important;
        }
      `}</style>

      <div className="appbar">
        <div className="title">웨이팅 신청</div>
      </div>

      <main className="page">
        <div className="shopname">{shopName}</div>
        <div className="hello">입장 순서가 되면 알려드릴게요.</div>

        <div className="cardbox">
          <div className="mb-3">
            <label className="form-label">이름</label>
            <input
              id="name"
              className="form-control"
              maxLength="50"
              placeholder="홍길동"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">전화번호</label>
            <input
              id="phone"
              className="form-control"
              maxLength="20"
              placeholder="01012345678"
              inputMode="numeric"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <div className="form-text">숫자만 입력해도 됩니다.</div>
          </div>

          <div className="mb-1">
            <label className="form-label">인원</label>
            <select
              id="people"
              className="form-select"
              value={people}
              onChange={(e) => setPeople(e.target.value)}
            >
              {Array.from({ length: 10 }).map((_, idx) => {
                const n = idx + 1;
                return (
                  <option key={n} value={n}>
                    {n}명
                  </option>
                );
              })}
            </select>
          </div>

          <div id="msg" dangerouslySetInnerHTML={{ __html: msgHtml }} />
        </div>
      </main>

      <div className="bottom-cta">
        <div className="wrap">
          <button id="btn" className="btn-brand" onClick={submit}>
            대기 등록하기
          </button>
        </div>
      </div>
    </>
  );
};

export default WaitingRegister;